// Which Firebase project this build talks to, shown so staging can never pass for production (F1-251,
// F2-453; W8 #10). The staging and production admin sites were identical: same layout, the same event
// shortName ("Midwest 2026"), so a "test" announcement could go to real families. The cue comes from the
// build's Firebase config, not from data, so no document edit can hide it or put it on production.
// Production ('spark-midwest') shows nothing and keeps its titles exactly as before.
import { firebaseConfig } from './env.ts'

export const PRODUCTION_PROJECT = 'spark-midwest'
export const STAGING_PROJECT = 'spark-midwest-staging'

export interface EnvironmentBand {
  /** Short, for the tab title prefix. */
  label: string
  /** The band's sentence. */
  text: string
}

export function environmentBand(projectId: string): EnvironmentBand | null {
  if (projectId === PRODUCTION_PROJECT) return null
  if (projectId === STAGING_PROJECT) return { label: 'STAGING', text: 'STAGING · This is the test site, not the live event.' }
  // The emulators, a demo project, or anything unexpected: never let it look like production either.
  return { label: 'TEST', text: `TEST · Project ${projectId || '(none)'}, not the live event.` }
}

export const ENV_BAND: EnvironmentBand | null = environmentBand(firebaseConfig.projectId)

/** A tab title, prefixed off production ("STAGING · Announcements · SPARK Admin"). */
export function pageTitle(title: string, band: EnvironmentBand | null = ENV_BAND): string {
  return band ? `${band.label} · ${title}` : title
}
